import { useTranslation } from "react-i18next";
import { DeleteManager } from "./delete-manager";
import { EditManager } from "./edit-manager";
import { ManagerPaycloud } from "../../types";
import { StatusBadge } from "./status-badge";
import { getBranchDisplayName } from "../../utils/branch-display-name";

interface ManagerItemProps {
  manager: ManagerPaycloud;
  onDeleteManager: (managerId: number) => void;
  fetchManagers: () => Promise<void>;
}

export function ManagerItem({ manager, onDeleteManager, fetchManagers }: ManagerItemProps) {
  const { t } = useTranslation();

  return (
    <div className="bg-[#2d2f32] rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-4">
            <StatusBadge status={manager.active} />
            <h3 className="text-lg font-semibold text-white">{manager.name}</h3>
          </div>
          <p className="text-[#83838b] ml-8">{manager.email}</p>
          <div className="mt-2 flex items-center gap-2 ml-8">
            <span className="text-sm text-[#83838b]">
              {t("managers.branchesIds")}:
            </span>
            <span className="text-sm font-medium text-white">
              {manager.branches.map((branch) => getBranchDisplayName(branch)).join(", ")}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2">

        {manager.active && (
          <>
          <EditManager
              manager={manager}
              fetchManagers={fetchManagers}
          />
          <DeleteManager
            managerId={manager.userId}
            deleteManager={onDeleteManager}
          /> 
          </>
          )}
        </div>
      </div>
    </div>
  );
} 